import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "modal-header auto" }
const _hoisted_2 = { class: "header-icon" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "modal-tabs" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "auto-notice" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "gubun-tabs" }
const _hoisted_12 = { class: "form-row two-cols compact" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "action-row" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "prediction-header" }
const _hoisted_20 = {
  key: 0,
  class: "match-count-badge"
}
const _hoisted_21 = {
  key: 1,
  class: "match-count-badge rule"
}
const _hoisted_22 = { class: "prediction-items" }
const _hoisted_23 = { class: "prediction-item" }
const _hoisted_24 = { class: "prediction-value" }
const _hoisted_25 = {
  key: 0,
  class: "code-hint"
}
const _hoisted_26 = { class: "prediction-item" }
const _hoisted_27 = { class: "prediction-value" }
const _hoisted_28 = {
  key: 0,
  class: "prediction-item rel-acc-item"
}
const _hoisted_29 = { class: "prediction-value" }
const _hoisted_30 = {
  key: 0,
  class: "code-hint"
}
const _hoisted_31 = {
  key: 1,
  class: "no-rel-acc-warning"
}
const _hoisted_32 = {
  key: 2,
  class: "balance-warning"
}
const _hoisted_33 = { class: "prediction-item source" }
const _hoisted_34 = {
  key: 0,
  class: "rel-acc-selection"
}
const _hoisted_35 = { class: "rel-acc-header" }
const _hoisted_36 = { class: "rel-acc-list" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "rel-acc-info" }
const _hoisted_39 = { class: "rel-acc-name" }
const _hoisted_40 = { class: "rel-acc-code" }
const _hoisted_41 = {
  key: 1,
  class: "alternatives"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "alt-info" }
const _hoisted_44 = { class: "alt-scode" }
const _hoisted_45 = {
  key: 0,
  class: "alt-rel-acc"
}
const _hoisted_46 = { class: "alt-count" }
const _hoisted_47 = {
  key: 2,
  class: "suggested-memos"
}
const _hoisted_48 = { class: "suggested-header" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "suggested-memo" }
const _hoisted_51 = { class: "suggested-count" }
const _hoisted_52 = {
  key: 1,
  class: "prediction-error"
}
const _hoisted_53 = { class: "modal-body excel-body" }
const _hoisted_54 = { class: "excel-upload-section" }
const _hoisted_55 = { class: "file-name" }
const _hoisted_56 = { class: "file-size" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "analysis-result"
}
const _hoisted_59 = { class: "analysis-summary" }
const _hoisted_60 = { class: "summary-text" }
const _hoisted_61 = { class: "summary-detail" }
const _hoisted_62 = {
  key: 2,
  class: "process-status"
}
const _hoisted_63 = { class: "process-header" }
const _hoisted_64 = {
  key: 0,
  class: "process-progress"
}
const _hoisted_65 = { class: "progress-info" }
const _hoisted_66 = { class: "phase-name" }
const _hoisted_67 = { class: "progress-count" }
const _hoisted_68 = { class: "progress-bar" }
const _hoisted_69 = {
  key: 1,
  class: "process-counts"
}
const _hoisted_70 = { class: "income-count" }
const _hoisted_71 = { class: "expense-count" }
const _hoisted_72 = {
  key: 2,
  class: "current-item"
}
const _hoisted_73 = { class: "item-info" }
const _hoisted_74 = { class: "sheet-badge" }
const _hoisted_75 = { class: "row-badge" }
const _hoisted_76 = { class: "item-detail" }
const _hoisted_77 = { class: "memo" }
const _hoisted_78 = {
  key: 0,
  class: "prediction"
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  key: 3,
  class: "process-result"
}
const _hoisted_81 = { class: "result-stats" }
const _hoisted_82 = { class: "stat income" }
const _hoisted_83 = { class: "stat expense" }
const _hoisted_84 = {
  key: 0,
  class: "stat error"
}
const _hoisted_85 = {
  key: 3,
  class: "analysis-error"
}
const _hoisted_86 = { class: "modal-footer" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { key: 1 }

import { ref, computed, watch, nextTick, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface FormData {
  gubun: 'IN' | 'OUT';
  inout_date: string;
  price: number;
  memo: string;
}

interface RelAccOption {
  scode: string;
  sname: string;
  totalIncome: number;
  usedAmount: number;
  availableBalance: number;
  isAffordable: boolean;
}

interface Prediction {
  scode: string | null;
  scode_name: string | null;
  funding: string | null;
  rel_acc: string | null;
  rel_acc_name: string | null;
  rel_acc_balance?: number;
  confidence: number;
  source: 'rule' | 'bigdata' | 'mixed' | null;
  matchCount: number;
  ruleKeyword: string | null;
  matchType: string | null;
  matchDescription: string | null;
  alternatives: Array<{
    scode: string;
    scode_name: string | null;
    funding: string;
    rel_acc: string;
    rel_acc_name: string | null;
    matchCount: number;
    keywordScore?: number;
  }>;
  suggestedMemos?: Array<{
    memo: string;
    usageCount: number;
  }>;
  availableRelAccounts?: RelAccOption[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmInoutAuto',
  props: {
    modelValue: { type: Boolean },
    currentYear: {},
    currentMonth: {}
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

// Props
const props = __props;

// Emits
const emit = __emit;

// 자금원 코드 매핑
const FUNDING_MAP: Record<string, string> = {
  '04': '자부담',
  '05': '후원금',
  '06': '수익사업',
  '07': '보조금'
};

// 상태
const dialogOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const activeTab = ref<'input' | 'excel'>('input');
const formRef = ref();
const isPredicting = ref(false);
const isSaving = ref(false);
const priceFocused = ref(false);
const predictionError = ref('');

// 엑셀 업로드 상태
const fileInputRef = ref<HTMLInputElement | null>(null);
const excelFile = ref<File | null>(null);
const isDragOver = ref(false);
const isAnalyzing = ref(false);
const excelAnalysis = ref<any>(null);
const excelError = ref('');

// 엑셀 데이터 처리 상태
const isProcessing = ref(false);
const processComplete = ref(false);
const processStatus = ref<{
  message: string;
  phase?: 'income' | 'expense' | string;
  current?: number;
  total?: number;
  incomeProcessed?: number;
  expenseProcessed?: number;
  currentItem?: {
    sheetName: string;
    rowIndex: number;
    memo: string;
    inout_date?: string;
    scode_name?: string;
    rel_acc_name?: string;
  };
}>({ message: '' });
const processLogs = ref<Array<{ type: string; message: string }>>([]);
const processResult = ref<{ incomeCount: number; expenseCount: number; errorCount: number }>({ incomeCount: 0, expenseCount: 0, errorCount: 0 });
const processLogRef = ref<HTMLElement | null>(null);

const formData = ref<FormData>({
  gubun: 'OUT',
  inout_date: '',
  price: 0,
  memo: ''
});

const prediction = ref<Prediction | null>(null);

// 금액 포맷팅
const formattedPrice = computed(() => {
  return formData.value.price ? formData.value.price.toLocaleString() : '';
});

// 예측 가능 여부
const canPredict = computed(() => {
  return formData.value.gubun && 
         formData.value.memo?.trim();
});

// 저장 가능 여부
const canSave = computed(() => {
  return formData.value.gubun &&
         formData.value.inout_date &&
         formData.value.price > 0 &&
         formData.value.memo?.trim() &&
         prediction.value?.scode;
});

// 헤더 타이틀
const getHeaderTitle = computed(() => {
  if (activeTab.value === 'excel') return '엑셀 업로드';
  return '자동 항목 추가';
});

const getHeaderSubtitle = computed(() => {
  if (activeTab.value === 'excel') return '엑셀 파일을 업로드하여 항목을 일괄 추가합니다';
  return 'AI가 계정코드, 자금원천, 상대계정을 추천합니다';
});

// 자금원천 이름 가져오기
const getFundingName = (code: string | null | undefined): string => {
  if (!code) return '-';
  return FUNDING_MAP[code] || code;
};

// 숫자 포맷팅
const formatNumber = (num: number | undefined): string => {
  if (num === undefined || num === null) return '0';
  return new Intl.NumberFormat('ko-KR').format(num);
};

// 추천 방식 이름
const getSourceName = (source: string | null): string => {
  if (!source) return '-';
  const names: Record<string, string> = {
    'rule': '규칙 기반',
    'bigdata': '빅데이터',
    'mixed': '복합 추천'
  };
  return names[source] || source;
};

// 신뢰도 클래스
const getConfidenceClass = (confidence: number): string => {
  if (confidence >= 0.8) return 'high';
  if (confidence >= 0.5) return 'medium';
  return 'low';
};

// 매핑된 컬럼 수 계산
const getTotalMappedColumns = (): number => {
  if (!excelAnalysis.value?.sheets) return 0;
  let count = 0;
  for (const sheet of excelAnalysis.value.sheets) {
    if (sheet.detectedHeader?.columnMapping) {
      count += sheet.detectedHeader.columnMapping.filter((m: any) => m.field).length;
    }
  }
  return count;
};

// 금액 입력 핸들러
const handlePriceInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const rawValue = target.value.replace(/[^0-9]/g, '');
  const numericValue = rawValue ? parseInt(rawValue, 10) : 0;
  formData.value.price = numericValue;
  target.value = numericValue ? numericValue.toLocaleString() : '';
};

const handlePriceKeydown = (event: KeyboardEvent) => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
  const isNumber = /^[0-9]$/.test(event.key);
  if (!isNumber && !allowedKeys.includes(event.key)) {
    event.preventDefault();
  }
};

// AI 예측 요청
const predictFields = async () => {
  if (!canPredict.value) return;
  
  isPredicting.value = true;
  prediction.value = null;
  predictionError.value = '';
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    const response = await axios.post('/api/fna/inout/predict', {
      gubun: formData.value.gubun,
      memo: formData.value.memo,
      price: formData.value.price,
      // 지출일 때 상대계정 추천을 위해 추가 정보 전달
      sisulCode,
      year: props.currentYear,
      month: props.currentMonth
    });
    
    if (response.data.success) {
      prediction.value = response.data.data;
      
      // 예측 결과가 없는 경우
      if (!prediction.value?.scode) {
        predictionError.value = '유사한 패턴을 찾을 수 없습니다. 적요를 다르게 입력해보세요.';
      }
    } else {
      predictionError.value = response.data.message || '예측에 실패했습니다.';
    }
  } catch (error: any) {
    console.error('예측 오류:', error);
    predictionError.value = error.response?.data?.message || '예측 중 오류가 발생했습니다.';
  } finally {
    isPredicting.value = false;
  }
};

// 대안 선택
const selectAlternative = (alt: { scode: string; scode_name: string | null; funding: string; rel_acc: string; rel_acc_name: string | null }) => {
  if (prediction.value) {
    prediction.value.scode = alt.scode;
    prediction.value.scode_name = alt.scode_name;
    prediction.value.funding = alt.funding;
    prediction.value.rel_acc = alt.rel_acc;
    prediction.value.rel_acc_name = alt.rel_acc_name;
  }
};

// 상대계정 선택
const selectRelAcc = (relAcc: { scode: string; sname: string; availableBalance: number }) => {
  if (prediction.value) {
    prediction.value.rel_acc = relAcc.scode;
    prediction.value.rel_acc_name = relAcc.sname;
    prediction.value.rel_acc_balance = relAcc.availableBalance;
  }
};

// 추천 적요 적용
const applyMemo = (memo: string) => {
  formData.value.memo = memo;
  // 다시 예측 실행
  predictFields();
};

// 저장
const saveInout = async () => {
  if (!canSave.value || !prediction.value) return;
  
  isSaving.value = true;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    const payload = {
      m_sisul_code: sisulCode,
      hi_gubun: formData.value.gubun,
      hi_scode: prediction.value.scode,
      hi_memo: formData.value.memo,
      hi_price: formData.value.price,
      hi_inout_date: formData.value.inout_date,
      hi_funding: prediction.value.funding,
      hi_rel_acc: prediction.value.rel_acc
    };
    
    await axios.post('/api/fna/inout', payload);
    
    emit('saved');
    closeDialog();
  } catch (error: any) {
    console.error('저장 오류:', error);
    predictionError.value = error.response?.data?.message || '저장 중 오류가 발생했습니다.';
  } finally {
    isSaving.value = false;
  }
};

// ============================================
// 엑셀 업로드 관련 함수
// ============================================

// 파일 입력 트리거
const triggerFileInput = () => {
  fileInputRef.value?.click();
};

// 파일 선택 핸들러
const handleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    setExcelFile(file);
  }
};

// 드래그 앤 드롭 핸들러
const handleDrop = (event: DragEvent) => {
  isDragOver.value = false;
  const file = event.dataTransfer?.files?.[0];
  if (file) {
    const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
    if (ext === '.xlsx' || ext === '.xls') {
      setExcelFile(file);
    } else {
      excelError.value = '엑셀 파일(xls, xlsx)만 업로드 가능합니다.';
    }
  }
};

// 파일 설정
const setExcelFile = (file: File) => {
  excelFile.value = file;
  excelAnalysis.value = null;
  excelError.value = '';
  // 이전 처리 상태 초기화
  processComplete.value = false;
  processStatus.value = { message: '' };
  processLogs.value = [];
  processResult.value = { incomeCount: 0, expenseCount: 0, errorCount: 0 };
};

// 파일 제거
const removeFile = () => {
  excelFile.value = null;
  excelAnalysis.value = null;
  excelError.value = '';
  if (fileInputRef.value) {
    fileInputRef.value.value = '';
  }
};

// 파일 크기 포맷
const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

// 엑셀 분석
const analyzeExcel = async () => {
  if (!excelFile.value) return;
  
  isAnalyzing.value = true;
  excelAnalysis.value = null;
  excelError.value = '';
  
  try {
    const formData = new FormData();
    formData.append('file', excelFile.value);
    
    const response = await axios.post('/api/fna/inout/excel/detect-headers', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    if (response.data.success) {
      excelAnalysis.value = response.data;
      console.log('엑셀 분석 결과:', response.data);
      console.log('시트 수:', response.data.sheets?.length);
      response.data.sheets?.forEach((sheet: any, idx: number) => {
        console.log(`시트 ${idx}: detectedHeader =`, sheet.detectedHeader);
      });
    } else {
      excelError.value = response.data.message || '분석에 실패했습니다.';
    }
  } catch (error: any) {
    console.error('엑셀 분석 오류:', error);
    excelError.value = error.response?.data?.message || '엑셀 파일 분석 중 오류가 발생했습니다.';
  } finally {
    isAnalyzing.value = false;
  }
};

// 엑셀 데이터 처리 (AI 분석 후 등록)
const processExcelData = async () => {
  if (!excelFile.value) return;
  
  const sisulCode = store.state.user?.m_sisul_code;
  if (!sisulCode) {
    excelError.value = '시설 코드를 찾을 수 없습니다.';
    return;
  }
  
  isProcessing.value = true;
  processComplete.value = false;
  processLogs.value = [];
  processStatus.value = { message: '처리 시작...' };
  processResult.value = { incomeCount: 0, expenseCount: 0, errorCount: 0 };
  
  // AbortController 생성
  abortController = new AbortController();
  
  const formData = new FormData();
  formData.append('file', excelFile.value);
  formData.append('sisulCode', sisulCode);
  formData.append('year', props.currentYear);
  formData.append('month', props.currentMonth);
  
  try {
    // SSE를 사용한 실시간 진행 상황 수신
    const response = await fetch('/api/fna/inout/excel/process', {
      method: 'POST',
      body: formData,
      signal: abortController.signal
    });
    
    if (!response.ok) {
      throw new Error('서버 오류가 발생했습니다.');
    }
    
    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    
    if (!reader) {
      throw new Error('스트림을 읽을 수 없습니다.');
    }
    
    let buffer = '';
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      
      buffer += decoder.decode(value, { stream: true });
      const events = buffer.split('\n\n');
      buffer = events.pop() || ''; // 마지막 불완전한 이벤트는 버퍼에 유지
      
      for (const event of events) {
        if (event.startsWith('data: ')) {
          try {
            const data = JSON.parse(event.slice(6));
            console.log('[SSE] 이벤트 수신:', data.type, data);
            handleProcessEvent(data);
          } catch (e) {
            console.error('[SSE] JSON 파싱 오류:', e, event);
          }
        }
      }
    }
  } catch (error: any) {
    // 사용자가 중단한 경우
    if (error.name === 'AbortError') {
      console.log('엑셀 처리가 사용자에 의해 중단됨');
      processStatus.value.message = '처리가 중단되었습니다.';
      processLogs.value.push({ type: 'warning', message: '처리가 사용자에 의해 중단되었습니다.' });
      emit('saved'); // 처리된 데이터 새로고침
    } else if (error.message?.includes('network') || error.name === 'TypeError') {
      // 네트워크 에러
      console.error('네트워크 오류:', error);
      processStatus.value.message = '연결이 끊어졌습니다.';
      processLogs.value.push({ type: 'error', message: '서버 연결이 끊어졌습니다. 처리된 데이터는 저장되었을 수 있습니다.' });
      emit('saved');
    } else {
      console.error('엑셀 처리 오류:', error);
      processStatus.value.message = '오류가 발생했습니다.';
      excelError.value = error.message || '처리 중 오류가 발생했습니다.';
    }
    isProcessing.value = false;
  } finally {
    abortController = null;
  }
};

// SSE 이벤트 처리
const handleProcessEvent = (data: any) => {
  switch (data.type) {
    case 'start':
    case 'sheet_start':
    case 'sheet_info':
    case 'sheet_skip':
    case 'analysis_complete':
      processStatus.value.message = data.message;
      processLogs.value.push({ type: 'info', message: data.message });
      break;
    
    // 전년도이월금 관련 이벤트
    case 'carryover_detected':
    case 'carryover_insert':
      processStatus.value.message = data.message;
      processLogs.value.push({ type: 'carryover', message: data.message });
      break;
      
    case 'carryover_complete':
      processStatus.value.message = data.message;
      processLogs.value.push({ type: 'success', message: `✓ ${data.message}` });
      scrollLogToBottom();
      break;
      
    case 'phase_start':
      processStatus.value = {
        message: data.message,
        phase: data.phase,
        current: 0,
        total: data.count
      };
      processLogs.value.push({ type: 'phase', message: data.message });
      break;
      
    case 'item_processing':
      processStatus.value = {
        ...processStatus.value,
        message: data.message,
        current: data.current,
        total: data.total,
        phase: data.phase,
        incomeProcessed: data.incomeProcessed,
        expenseProcessed: data.expenseProcessed,
        currentItem: data.memo ? {
          sheetName: data.sheetName || '',
          rowIndex: data.rowIndex || 0,
          memo: data.memo,
          inout_date: data.inout_date
        } : processStatus.value.currentItem
      };
      break;
      
    case 'item_complete':
      processStatus.value = {
        ...processStatus.value,
        message: data.message,
        current: data.current,
        currentItem: {
          sheetName: processStatus.value.currentItem?.sheetName || '',
          rowIndex: processStatus.value.currentItem?.rowIndex || 0,
          memo: data.memo,
          scode_name: data.scode_name,
          rel_acc_name: data.rel_acc_name
        }
      };
      processLogs.value.push({ type: 'success', message: data.message });
      scrollLogToBottom();
      break;
      
    case 'item_error':
      processLogs.value.push({ type: 'error', message: `오류: ${data.memo} - ${data.error}` });
      scrollLogToBottom();
      break;
      
    case 'phase_complete':
      processStatus.value.message = data.message;
      processLogs.value.push({ type: 'phase', message: data.message });
      break;
      
    case 'complete':
      processComplete.value = true;
      isProcessing.value = false;
      processStatus.value = { message: data.message };
      processResult.value = {
        incomeCount: data.incomeCount,
        expenseCount: data.expenseCount,
        errorCount: data.errorCount
      };
      processLogs.value.push({ type: 'complete', message: data.message });
      emit('saved'); // 데이터 새로고침
      break;
    
    case 'cancelled':
      isProcessing.value = false;
      processStatus.value = { message: data.message };
      processLogs.value.push({ type: 'warning', message: data.message });
      emit('saved'); // 처리된 데이터라도 새로고침
      break;
      
    case 'error':
      excelError.value = data.message;
      isProcessing.value = false;
      processLogs.value.push({ type: 'error', message: data.message });
      break;
  }
};

// 로그 스크롤
const scrollLogToBottom = () => {
  nextTick(() => {
    if (processLogRef.value) {
      processLogRef.value.scrollTop = processLogRef.value.scrollHeight;
    }
  });
};

// 로그 아이콘
const getLogIcon = (type: string): string => {
  switch (type) {
    case 'success': return 'mdi-check';
    case 'error': return 'mdi-alert-circle';
    case 'warning': return 'mdi-alert';
    case 'phase': return 'mdi-flag';
    case 'complete': return 'mdi-check-circle';
    case 'carryover': return 'mdi-bank-transfer';
    default: return 'mdi-information';
  }
};

// 로그 아이콘 색상
const getLogIconColor = (type: string): string => {
  switch (type) {
    case 'success': return '#10b981';
    case 'error': return '#ef4444';
    case 'warning': return '#f59e0b';
    case 'phase': return '#6366f1';
    case 'complete': return '#10b981';
    case 'carryover': return '#f59e0b';
    default: return '#64748b';
  }
};

// 처리 완료 후
const onProcessComplete = () => {
  emit('saved');
  closeDialog();
};

// SSE 연결 중단을 위한 AbortController
let abortController: AbortController | null = null;

// 다이얼로그 닫기
const closeDialog = () => {
  // 처리 중이면 확인
  if (isProcessing.value) {
    if (!confirm('엑셀 처리가 진행 중입니다. 중단하시겠습니까?\n중단하면 현재까지 처리된 데이터만 저장됩니다.')) {
      return;
    }
    // SSE 연결 중단
    cancelExcelProcess();
  }
  dialogOpen.value = false;
  resetForm();
};

// 엑셀 처리 중단
const cancelExcelProcess = () => {
  if (abortController) {
    abortController.abort();
    abortController = null;
  }
  isProcessing.value = false;
  processStatus.value.message = '처리가 중단되었습니다.';
};

// 폼 초기화
const resetForm = () => {
  const defaultDate = `${props.currentYear}-${props.currentMonth}-01`;
  formData.value = {
    gubun: 'OUT',
    inout_date: defaultDate,
    price: 0,
    memo: ''
  };
  prediction.value = null;
  predictionError.value = '';
  activeTab.value = 'input';
  // 엑셀 상태 초기화
  excelFile.value = null;
  excelAnalysis.value = null;
  excelError.value = '';
  // 엑셀 처리 상태 초기화
  isProcessing.value = false;
  processComplete.value = false;
  processStatus.value = { message: '' };
  processLogs.value = [];
  processResult.value = { incomeCount: 0, expenseCount: 0, errorCount: 0 };
};

// 다이얼로그가 열릴 때 폼 초기화
watch(dialogOpen, (newVal) => {
  if (newVal) {
    resetForm();
  }
});

// 페이지 이탈 시 경고 핸들러
const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  if (isProcessing.value) {
    e.preventDefault();
    e.returnValue = '엑셀 처리가 진행 중입니다. 페이지를 떠나시겠습니까?';
    return e.returnValue;
  }
};

// 컴포넌트 마운트/언마운트 시 이벤트 리스너 관리
onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
  // 처리 중이었다면 중단
  if (isProcessing.value && abortController) {
    abortController.abort();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogOpen.value,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogOpen).value = $event)),
    "max-width": activeTab.value === 'excel' ? '700' : '520'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["inout-auto-modal", { 'excel-mode': activeTab.value === 'excel' }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              size: "24",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-robot", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(getHeaderTitle.value), 1),
            _createElementVNode("p", null, _toDisplayString(getHeaderSubtitle.value), 1)
          ]),
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeDialog,
            disabled: isProcessing.value && !processComplete.value
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["modal-tab", { active: activeTab.value === 'input' }]),
            disabled: isProcessing.value && !processComplete.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'input'))
          }, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("mdi-plus-circle", -1)
              ]))]),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createTextVNode(" 항목 추가 ", -1))
          ], 10, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["modal-tab excel", { active: activeTab.value === 'excel' }]),
            disabled: isProcessing.value && !processComplete.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'excel'))
          }, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("mdi-file-excel", -1)
              ]))]),
              _: 1
            }),
            _cache[16] || (_cache[16] = _createTextVNode(" 엑셀 업로드 ", -1))
          ], 10, _hoisted_7)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#f59e0b"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("mdi-lightbulb-on", -1)
              ]))]),
              _: 1
            }),
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "수입/지출, 출납일자, 금액, 적요만 입력하면 나머지는 자동으로 추천됩니다.", -1))
          ]),
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["gubun-tab income", { active: formData.value.gubun === 'IN' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (formData.value.gubun = 'IN'))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("mdi-plus-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[20] || (_cache[20] = _createTextVNode(" 수입 ", -1))
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["gubun-tab expense", { active: formData.value.gubun === 'OUT' }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (formData.value.gubun = 'OUT'))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-minus-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[22] || (_cache[22] = _createTextVNode(" 지출 ", -1))
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label required" }, "출납일자", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.inout_date) = $event))
                  }, null, 512), [
                    [_vModelText, formData.value.inout_date]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label required" }, "금액", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["price-input-box", { focus: priceFocused.value }])
                  }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "price-field",
                      value: formattedPrice.value,
                      onInput: handlePriceInput,
                      onKeydown: handlePriceKeydown,
                      onFocus: _cache[5] || (_cache[5] = ($event: any) => (priceFocused.value = true)),
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (priceFocused.value = false)),
                      placeholder: "0"
                    }, null, 40, _hoisted_15),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "price-unit" }, "원", -1))
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label required" }, "적요", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.memo) = $event)),
                  placeholder: "적요를 입력하세요 (예: 직원음료, 본인부담금 등)",
                  onKeyup: _withKeys(predictFields, ["enter"])
                }, null, 544), [
                  [_vModelText, formData.value.memo]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn-predict", { loading: isPredicting.value }]),
                  onClick: predictFields,
                  disabled: !canPredict.value || isPredicting.value
                }, [
                  (isPredicting.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "18",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode("mdi-auto-fix", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[28] || (_cache[28] = _createTextVNode(" AI 추천 받기 ", -1))
                      ], 64))
                ], 10, _hoisted_18)
              ]),
              (prediction.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["prediction-result", { 'high-confidence': prediction.value.confidence >= 0.8 }])
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: prediction.value.confidence >= 0.8 ? '#10b981' : '#f59e0b'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(prediction.value.confidence >= 0.8 ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _cache[29] || (_cache[29] = _createElementVNode("span", null, "AI 추천 결과", -1)),
                      (prediction.value.matchCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(prediction.value.matchCount) + "건 매칭 ", 1))
                        : (prediction.value.ruleKeyword)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, " \"" + _toDisplayString(prediction.value.ruleKeyword) + "\" 규칙 ", 1))
                          : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["confidence-badge", getConfidenceClass(prediction.value.confidence)])
                      }, " 신뢰도 " + _toDisplayString(Math.round(prediction.value.confidence * 100)) + "% ", 3)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "prediction-label" }, "계정명", -1)),
                        _createElementVNode("span", _hoisted_24, [
                          _createTextVNode(_toDisplayString(prediction.value.scode_name || prediction.value.scode || '-') + " ", 1),
                          (prediction.value.scode && prediction.value.scode_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(prediction.value.scode) + ")", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "prediction-label" }, "자금원천", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(getFundingName(prediction.value.funding)), 1)
                      ]),
                      (formData.value.gubun === 'OUT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "prediction-label" }, "상대계정", -1)),
                            _createElementVNode("span", _hoisted_29, [
                              _createTextVNode(_toDisplayString(prediction.value.rel_acc_name || prediction.value.rel_acc || '-') + " ", 1),
                              (prediction.value.rel_acc && prediction.value.rel_acc_name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "(" + _toDisplayString(prediction.value.rel_acc) + ")", 1))
                                : _createCommentVNode("", true),
                              (prediction.value.rel_acc_balance !== undefined)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["balance-info", { sufficient: prediction.value.rel_acc_balance >= formData.value.price, insufficient: prediction.value.rel_acc_balance < formData.value.price }])
                                  }, " 잔액 " + _toDisplayString(formatNumber(prediction.value.rel_acc_balance)) + "원 ", 3))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (formData.value.gubun === 'OUT' && !prediction.value.rel_acc && prediction.value.availableRelAccounts && prediction.value.availableRelAccounts.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#ef4444"
                            }, {
                              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                _createTextVNode("mdi-alert", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "해당 월에 등록된 수입 항목이 없습니다. 먼저 수입을 등록해주세요.", -1))
                          ]))
                        : (formData.value.gubun === 'OUT' && prediction.value.rel_acc_balance !== undefined && prediction.value.rel_acc_balance < formData.value.price)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                color: "#f59e0b"
                              }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createTextVNode("mdi-alert-circle", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[36] || (_cache[36] = _createElementVNode("span", null, "상대계정 잔액이 부족합니다. 다른 상대계정을 선택하세요.", -1))
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "prediction-label" }, "분석 방식", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["prediction-value source-tag", prediction.value.matchType || prediction.value.source])
                        }, _toDisplayString(prediction.value.matchDescription || getSourceName(prediction.value.source)), 3)
                      ])
                    ]),
                    (formData.value.gubun === 'OUT' && prediction.value.availableRelAccounts && prediction.value.availableRelAccounts.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#6366f1"
                            }, {
                              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                _createTextVNode("mdi-swap-horizontal", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[39] || (_cache[39] = _createElementVNode("span", null, "상대계정 선택", -1))
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prediction.value.availableRelAccounts, (relAcc, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: _normalizeClass(["rel-acc-option", { 
                    active: prediction.value.rel_acc === relAcc.scode,
                    disabled: relAcc.availableBalance < formData.value.price
                  }]),
                                onClick: ($event: any) => (selectRelAcc(relAcc))
                              }, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(relAcc.sname), 1),
                                  _createElementVNode("span", _hoisted_40, "(" + _toDisplayString(relAcc.scode) + ")", 1)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["rel-acc-balance", { insufficient: relAcc.availableBalance < formData.value.price }])
                                }, _toDisplayString(formatNumber(relAcc.availableBalance)) + "원 ", 3)
                              ], 10, _hoisted_37))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (prediction.value.alternatives && prediction.value.alternatives.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "alternatives-header" }, "다른 추천", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prediction.value.alternatives, (alt, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: idx,
                              class: "alternative-item",
                              onClick: ($event: any) => (selectAlternative(alt))
                            }, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(alt.scode_name || alt.scode), 1),
                                (alt.rel_acc)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, " → " + _toDisplayString(alt.rel_acc_name || alt.rel_acc), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_46, _toDisplayString(alt.matchCount) + "건", 1)
                            ], 8, _hoisted_42))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (prediction.value.suggestedMemos && prediction.value.suggestedMemos.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#6366f1"
                            }, {
                              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                _createTextVNode("mdi-lightbulb-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[42] || (_cache[42] = _createElementVNode("span", null, "적요 변경 추천", -1))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prediction.value.suggestedMemos, (sm, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: idx,
                              class: "suggested-item",
                              onClick: ($event: any) => (applyMemo(sm.memo))
                            }, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(sm.memo), 1),
                              _createElementVNode("span", _hoisted_51, _toDisplayString(sm.usageCount) + "회 사용", 1)
                            ], 8, _hoisted_49))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (predictionError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "#ef4444"
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode("mdi-alert-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(predictionError.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ], 512), [
          [_vShow, activeTab.value === 'input']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", {
              class: _normalizeClass(["upload-dropzone", { 'drag-over': isDragOver.value, 'has-file': excelFile.value }]),
              onDragover: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isDragOver.value = true), ["prevent"])),
              onDragleave: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (isDragOver.value = false), ["prevent"])),
              onDrop: _withModifiers(handleDrop, ["prevent"]),
              onClick: triggerFileInput
            }, [
              _createElementVNode("input", {
                ref_key: "fileInputRef",
                ref: fileInputRef,
                type: "file",
                accept: ".xlsx,.xls",
                onChange: handleFileSelect,
                hidden: ""
              }, null, 544),
              (!excelFile.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_icon, {
                      size: "48",
                      color: "#94a3b8"
                    }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-file-excel-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createElementVNode("p", { class: "upload-text" }, "엑셀 파일을 드래그하거나 클릭하여 업로드", -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("p", { class: "upload-hint" }, ".xlsx, .xls 파일만 지원", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      color: "#10b981"
                    }, {
                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                        _createTextVNode("mdi-file-excel", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("p", _hoisted_55, _toDisplayString(excelFile.value.name), 1),
                    _createElementVNode("p", _hoisted_56, _toDisplayString(formatFileSize(excelFile.value.size)), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-remove-file",
                      onClick: _withModifiers(removeFile, ["stop"])
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ], 64))
            ], 34),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn-analyze", { loading: isAnalyzing.value }]),
              onClick: analyzeExcel,
              disabled: !excelFile.value || isAnalyzing.value
            }, [
              (isAnalyzing.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                        _createTextVNode("mdi-table-search", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[50] || (_cache[50] = _createTextVNode(" 헤더 분석하기 ", -1))
                  ], 64))
            ], 10, _hoisted_57),
            (excelAnalysis.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#10b981"
                    }, {
                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                        _createTextVNode("mdi-check-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_60, [
                      _cache[52] || (_cache[52] = _createElementVNode("span", { class: "summary-title" }, "분석 완료", -1)),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(excelAnalysis.value.sheetCount) + "개 시트 · " + _toDisplayString(getTotalMappedColumns()) + "개 컬럼 매핑 ", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (excelAnalysis.value && !isProcessing.value && !processComplete.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn-process",
                  onClick: processExcelData
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createTextVNode("mdi-database-import", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[54] || (_cache[54] = _createTextVNode(" AI 분석 후 데이터 등록하기 ", -1))
                ]))
              : _createCommentVNode("", true),
            (isProcessing.value || processComplete.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: processComplete.value ? '#10b981' : '#6366f1'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(processComplete.value ? 'mdi-check-circle' : 'mdi-loading mdi-spin'), 1)
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _createElementVNode("span", null, _toDisplayString(processStatus.value.message), 1)
                  ]),
                  ((processStatus.value.total ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("span", _hoisted_66, _toDisplayString(processStatus.value.phase === 'income' ? '수입 처리' : processStatus.value.phase === 'expense' ? '지출 처리' : '데이터 처리'), 1),
                          _createElementVNode("span", _hoisted_67, _toDisplayString(processStatus.value.current || 0) + " / " + _toDisplayString(processStatus.value.total || 0) + " (" + _toDisplayString(Math.round(((processStatus.value.current || 0) / (processStatus.value.total || 1)) * 100)) + "%) ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress-fill", processStatus.value.phase || 'income']),
                            style: _normalizeStyle({ width: `${((processStatus.value.current || 0) / (processStatus.value.total || 1)) * 100}%` })
                          }, null, 6)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (processStatus.value.incomeProcessed !== undefined || processStatus.value.expenseProcessed !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, "수입: " + _toDisplayString(processStatus.value.incomeProcessed || 0) + "건", 1),
                        _createElementVNode("span", _hoisted_71, "지출: " + _toDisplayString(processStatus.value.expenseProcessed || 0) + "건", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (processStatus.value.currentItem)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(processStatus.value.currentItem.sheetName), 1),
                          _createElementVNode("span", _hoisted_75, _toDisplayString(processStatus.value.currentItem.rowIndex) + "행", 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("span", _hoisted_77, _toDisplayString(processStatus.value.currentItem.memo), 1),
                          (processStatus.value.currentItem.scode_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                _createTextVNode(" → " + _toDisplayString(processStatus.value.currentItem.scode_name) + " ", 1),
                                (processStatus.value.currentItem.rel_acc_name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, " / " + _toDisplayString(processStatus.value.currentItem.rel_acc_name), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "process-log",
                    ref_key: "processLogRef",
                    ref: processLogRef
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processLogs.value.slice(-20), (log, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: _normalizeClass(["log-item", log.type])
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "12",
                          color: getLogIconColor(log.type)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getLogIcon(log.type)), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]),
                        _createElementVNode("span", null, _toDisplayString(log.message), 1)
                      ], 2))
                    }), 128))
                  ], 512),
                  (processComplete.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              color: "#10b981"
                            }, {
                              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                _createTextVNode("mdi-plus-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("span", null, "수입 " + _toDisplayString(processResult.value.incomeCount) + "건", 1)
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              color: "#ef4444"
                            }, {
                              default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                _createTextVNode("mdi-minus-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("span", null, "지출 " + _toDisplayString(processResult.value.expenseCount) + "건", 1)
                          ]),
                          (processResult.value.errorCount > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createVNode(_component_v_icon, {
                                  size: "16",
                                  color: "#f59e0b"
                                }, {
                                  default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                    _createTextVNode("mdi-alert", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, "오류 " + _toDisplayString(processResult.value.errorCount) + "건", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-done",
                          onClick: onProcessComplete
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[59] || (_cache[59] = _createTextVNode(" 완료 ", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (excelError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: "#ef4444"
                  }, {
                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                      _createTextVNode("mdi-alert-circle", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(excelError.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, activeTab.value === 'excel']
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-cancel",
            onClick: closeDialog
          }, "닫기"),
          (activeTab.value === 'input')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["btn-submit", { disabled: !canSave.value, loading: isSaving.value }]),
                onClick: saveInout,
                disabled: !canSave.value || isSaving.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "18",
                      width: "2",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_88, "저장하기"))
              ], 10, _hoisted_87))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "max-width"]))
}
}

})